import React, { useRef, useEffect } from 'react'
import {
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap"
import moment from 'moment'
import MainService from '../../../../Services/MainService';
import { ADMIN_USER_TYPE_ID, fieldLengths } from '../../../../Constants/MainKeys';
import { useSelector } from 'react-redux';

export default function AnswerModal({
  cancel,
  currentItem,
  onChange,
  isClientAnswer,
  setIsClientAnswer,
  answerText,
  isLoading,
  handleKeyDown,
  onSubmit,
  setAnswerText
}) {

  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);
  const { user } = useSelector(state => state.Login);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    setTimeout(() => {
      scrollToBottom();
      const el = document.getElementById("answerText");
      if (el && currentItem.ticketStatus !== 4) {
        el.focus();
      }
    }, 100);
  }, [currentItem])

  if (!currentItem) { return false; }

  return (
    <Modal isOpen={currentItem}
      toggle={cancel}
      size="lg"
      centered
      scrollable
    >
      <ModalHeader toggle={cancel}>Reply to Message</ModalHeader>
      <ModalBody>
        <div className=' d-flex flex-column gap-3'>
          <div className='d-flex justify-content-end message-right' >
            <div className='py-2 px-3' style={{ width: '100%', borderRadius: "10px", backgroundColor: user.userTypeId === ADMIN_USER_TYPE_ID ? "#D9E9F9" : "#D4EFE7" }}>
              <p className='mb-0' style={{ wordBreak: "break-all" }}>{currentItem?.message}</p>
              <small className='d-block text-end fw-500'>{moment(MainService.convertUTCDateToLocalDate(new Date(currentItem.createTime))).format('HH:mm ll ')}</small>
            </div>
          </div>
          {
            currentItem.ticketAnswers && currentItem.ticketAnswers.length ? (
              currentItem.ticketAnswers.map((item, index) => {
                const isAdmin = user.userTypeId === ADMIN_USER_TYPE_ID;
                const isRight = isAdmin ? !item.isClientAnswer : item.isClientAnswer;
                const justifyClass = isRight ? 'justify-content-end message-right' : 'justify-content-start message-left';
                const bgColor = isRight ? '#D4EFE7' : '#D9E9F9';
                return (
                  <div key={index} className={`d-flex ${justifyClass}`}>
                    <div className="px-3 py-2 pb-1" style={{ maxWidth: '80%', borderRadius: '10px', backgroundColor: bgColor }}>
                      <p style={{ wordBreak: "break-all" }}>{item?.answer}</p>
                      <small className="d-block text-end fw-500">
                        {moment(MainService.convertUTCDateToLocalDate(new Date(item.createTime))).format('HH:mm ll')}
                      </small>
                    </div>
                  </div>
                );
              })
            ) : null
          }
        </div>
        <div ref={messagesEndRef} />
      </ModalBody>
      {
        currentItem.ticketStatus === 4 ?
          <ModalFooter><span className='d-block text-center fw-500'>This ticket has been closed.</span></ModalFooter> :
          <ModalFooter>
            {
              user.userTypeId === ADMIN_USER_TYPE_ID ?
                <div className="form-check mb-2 ">
                  <Input
                    id="isClientAnswer"
                    name="isClientAnswer"
                    className="custom-checkbox"
                    type="checkbox"
                    checked={isClientAnswer}
                    onChange={event => setIsClientAnswer(event.target.checked)}
                  />
                  <Label
                    className="form-check-label cursor-pointer"
                    htmlFor="isClientAnswer"
                  >
                    Client Answer
                  </Label>
                </div>
                : null
            }
            <div className={`answer-block ${currentItem.ticketStatus === 4 ? "disabled" : ""} `}>
              <Input
                id="answerText"
                type="textarea"
                value={answerText}
                rows={3}
                ref={inputRef}
                // autoFocus
                disabled={isLoading}
                style={{ resize: "none" }}
                placeholder='Type your reply here...'
                className={`form-control`}
                onKeyDown={handleKeyDown}
                onChange={(event) => onChange(event, setAnswerText, fieldLengths.length_2000)}
              />
              <i className={`bx bxs-send send-icon ${!answerText.trim().length || isLoading ? "disabled" : ""}`} onClick={onSubmit}></i>
            </div>
          </ModalFooter>
      }

    </Modal>
  )
}
